import LocationRequired from '@/views/location/views/LocationRequired.vue';

export default [
  {
    path: '/location-required/',
    component: LocationRequired  
    //component: () => import('@/views/location/views/LocationRequired.vue') 
  }
];
